export default {
  payWelfareText: 'Avantages de Recharge',
  blackFridayDiscount: 'Réduction Limitée de Black Friday',
  shareGift: 'Cadeau de partage',
  vipWeeklyWelfare: 'Remise hebdomadaire VIP',
  exchangeCoupon: 'Coupon',
  firstPayOff: "Jusqu'à -15% de pour le 1er Achat",
  blackFridayEvent: 'Événement Black Friday',
  limitedTimeOff: '-10% en temps limité',
  claimCoupon: 'Réclamer Maintenant',
  blackFridayTimedCoupon: 'Coupon Black Friday',
  timeLeft: 'Temps restant : ',
  claimTimeCoupon: 'Réclamer 10% de réduction maintenant !',
  points: 'Points : ${point}',
  costPointTip: 'Echangez vos points contre des coupons',
  maxPointTip: "Chaque compte peut utiliser jusqu'à 500 points.",
  discountOff: '-10%',
  highestDiscount: "Jusqu'à -${discount} ",
  needPoint: 'Nécessite ${point} pts',
  changeCurrency: 'Changer de devise',
  claim: 'Réclamer',
  claimSucc: 'Réclamé',
  claimFail: 'Échec',
  pointNotEnough: 'Points insuffisants',
  afterClaimPoint: 'Points restants : ${point}',
  footTips1: '1 seul coupon peut être utilisé par commande.',
  footTips2:
    'Les coupons ne peuvent pas être utilisés pour acheter des devises/jetons en jeu.',
  footTips3:
    "Nous nous réservons le droit d'interprétation finale de cet événement.",
  ruleTitleText: "Règles de l'Événement",
  ruleTime:
    "Durée de l'événement : 24 Nov 2023 à 00:00 - Nov. 26 2023 à 23h59 (UTC)",
  bfRuleText1:
    "1. 400 points seront attribués à votre compte lorsque vous vous connecterez à la page de recharge officielle pour la première fois pendant l'événement. Vous pouvez échanger jusqu'à 500 points contre des coupons.",
  bfRuleText2:
    "2. Vous pouvez échanger les points Black Friday contre des coupons pendant l'événement.",
  bfRuleText3:
    '3. Vous ne pouvez utiliser que 1 seul coupon par commande. Les coupons ne peuvent pas être utilisés pour acheter des devises/jetons en jeu.',
  bfRuleText4:
    "4. Pour les transactions, nous n'acceptons que les devises suivantes :",
  ableCoinsType: '/',
  bfRuleText5:
    '5. Vous ne pouvez pas changer de devise une fois la transaction effectuée. Les points échangés ne peuvent pas être remboursés.',
  bfRuleText6:
    '6. Les coupons Black Friday ne sont valables que pendant 7 jours.',
  bfRuleText7:
    "7. Nous nous réservons le droit d'interprétation finale de cet événement.",
  thanksTip:
    "Nous vous remercions de votre participation. Rejoignez notre communauté officielle pour plus d'informations sur l'événement.",
  exchangePoints: 'Échange',
  exchangeCode: "Entrez le code d'échange.",
  enterExchangeCode: "Veuillez saisir le code d'échange.",
  exchangeText: 'Échange',
  confirmGet: 'Confirmer',
  couponUsedWay:
    "Le coupon ne peut être utilisé qu'avec des devises spécifiques, veuillez confirmer votre devise.",
  confirmText: 'Confirmer',
  exchangeSucc: 'Échangé',
  aboutCoins: 'À propos des Devises/Jetons en jeu',
  aboutCoinsText:
    "Vous pouvez échanger des devises/jetons en jeu contre tous les packs et privilèges, à l'exception de la devise/token de jeu elle-même.",
  known: 'OK',
  codeText: 'Code',
  codeInvalid: 'Code non valide !',
  hasExchanged: "Vous ne pouvez pas réclamer d'autres codes.",
  hideText: 'Cacher',
  //黑五的报错码
  'bf-20001': 'Non connecté',
  'bf-20002': "Erreur de paramètre. Veuillez réessayer d'entrer l'événement.",
  'bf-20003': 'Points insuffisants',
  'bf-20004':
    'Échec ! Veuillez réessayer plus tard ou contacter le service clientèle.',
  'bf-20005': 'Réclamé',
  'bf-20015': "L'événement n'est actuellement pas disponible.",
  'bf-20016': "L'événement est terminé.",
  bfShareText: 'Réclamer 10% de réduction maintenant !',
  rightsCenterBtn: 'Centre des Membres Premium',
  payBtn: 'TOP UP',
  hasEqualRewardMuglo: 'Up to 1800 Diamonds BONUS from official website top-up!',
  productInterceptPopupTitle: 'Purchase Failed',
  productInterceptPopupTip: 'This item is not available in your region.<br>Please contact customer support if you have any questions.',
  productInterceptPopupConfirm: 'OK',
  vipHeadAwardText285 : 'Gloire extraordinaire (Permanent)',
  '-': '-'
};
